'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initializeVisitorOnlineChannel = undefined;

var _getInitialOnlineConversation = require('../selectors/getInitialOnlineConversation');

var _getInitialOnlineConversation2 = _interopRequireDefault(_getInitialOnlineConversation);

var _addConversation = require('./ConversationsActions/addConversation');

var _buildStubbedThread = require('../threads/factories/buildStubbedThread');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initializeConversation = function initializeConversation(conversation, channel, threadId) {
  return conversation.set('channel', channel).set('threadId', threadId);
};

var initializeVisitorOnlineChannel = exports.initializeVisitorOnlineChannel = function initializeVisitorOnlineChannel(channel, threadId) {
  return function (dispatch, getState) {
    var initialOnlineConversation = (0, _getInitialOnlineConversation2.default)(getState());

    var initializedConversation = initializeConversation(initialOnlineConversation, channel, threadId);

    dispatch((0, _addConversation.addConversation)(initializedConversation));

    // resets STUBBED_CHANNEL conversation
    // for use with new threads
    dispatch((0, _addConversation.addConversation)((0, _buildStubbedThread.buildStubbedThread)()));
  };
};


//////////////////
// WEBPACK FOOTER
// ./js/actions/initializeVisitorOnlineChannel.js
// module id = 525
// module chunks = 2 3